import { UnreadCountDto, UserStatsDto } from 'booksprout'
import state, { defaultState, resetNotificationState } from './state'
import {
  LoginRedirectData,
  ShowMessageDialogData,
  StoreRedirectData,
  UINotification,
  UINotificationType
} from './types'

export function _resetState () {
  Object.assign(state(), defaultState())
}

/**
 * De-duplicated by message: the same error arriving from three failed requests should show once.
 * Carried over from the Vuex mutation.
 */
export function _notifyError (message: string) {
  const s = state()

  if (s.notifications.find(f => f.message === message) === void 0) {
    const notification: UINotification = {
      type: UINotificationType.Error,
      message
    }
    s.notifications.push(notification)
  }
}

export function _clearNotifications () {
  state().notifications = resetNotificationState()
}

export function _setUnreadMessageCount (count: number) {
  state().unreadMessageCount = count
}

export function _setUnreadNotificationCount (unreadCountDto: UnreadCountDto) {
  state().unreadNotificationCount = unreadCountDto
}

export function _redirectTo (data: StoreRedirectData | undefined) {
  state().redirect = data
}

export function _showLoginNotification (data: LoginRedirectData) {
  const s = state()

  s.triggerLoginNotification = data.show
  s.loginForwardUrl = data.show ? data.forwardUrl : ''
}

/**
 * Clearing blanks the message and params in place rather than replacing the object — carried over
 * from the Vuex mutation, which the dialog's watchers depend on.
 */
export function _showMessageDialog (data: ShowMessageDialogData) {
  const s = state()

  s.showMessageDialog = data
  if (!data.show) {
    s.showMessageDialog.message = ''
    s.showMessageDialog.optionalParams = []
  }
}

export function _setUserStats (stats: UserStatsDto) {
  state().userStats = stats
}

export function _setReadyToRender (isReadyToRender: boolean) {
  state().isReadyToRender = isReadyToRender
}

export function _setLastError (error: string) {
  state().lastError = error
}
